// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2Orvw","filesListContainer":"PosDisputesFiles_filesListContainer__1gyUP","filesButton":"PosDisputesFiles_filesButton__171EE"};